const PB_API_PATH = '/api/platform-billing-orchestration';
export const V2 = '/v2';

const LOCATIONS_PATH = PB_API_PATH + '/locations';
export const LOCATION_SITE_LIST_PATH = LOCATIONS_PATH + '/site/mapping';

export const PAYMENTS_PATH = PB_API_PATH + '/paymentMethod';
export const PAYMENT_DEFAULT_PATH = PAYMENTS_PATH + '/default';

export const CREDIT_CARD_PATH = PB_API_PATH + '/card';
export const DELETE_CREDIT_CARD_PATH = CREDIT_CARD_PATH + '/creditcardid';

export const POST_ECHECK_PATH = PB_API_PATH + '/echeck';
